import styled from 'styled-components';
import theme from 'src/theme';

export const Wrapper = styled.div`
    flex: 0 0 auto;
    max-width: 30%;
    position: relative;
`;

export const UpperWrapper = styled.div`
    display: flex;
    align-items: start;
    justify-content: space-between;
`;

export const FiltersSelectionWrapper = styled.div`
    color: ${({ theme }) => theme.colors.text.pink};
    font-weight: 400;
    font-size: 0.9rem;
    padding: 2px;
    position: relative;
    .selected-rotation-label {
        font-weight: 500;
        margin-right: 3px;
    }
`;

export const SelectedRotationsWrapper = styled.div`
    font-weight: 400;
    font-size: 0.9rem;
    position: relative;
    margin: 0 0 0 10px;
    .info-text {
        display: block;
        font-size: 0.7rem;
    }
`;


export const VoyageStatusMarker = styled.span<{ status: string }>`
    display: inline-block;
    font-size: 0.8em;
    padding: 2px 6px;
    border-radius: 4px;
    margin-left: auto;
    margin-right: 5px;
    background-color: ${(props) => {
        switch (props.status) {
            case 'completed':
                return '#aaa'; // Green for completed
            case 'commenced':
                return '#3498db'; // Blue for ongoing
            case 'scheduled':
                return '#f39c12'; // Orange for scheduled
            default:
                return '#95a5a6'; // Gray for others
        }
    }};
    color: white;
`;

export const VoyageSelectionList = styled.div`
    &.is-selected {
        background: ${theme.legacyColors.selectedBackground};
        border: 1px solid #${theme.legacyColors.selectedBorder};
        color: ${theme.legacyColors.selectedColor};
        h5 {
            color: ${({ theme }) => theme.colors.text.white};
        }
    }

    .voyage-list {
        font-size: 0.8rem;
        height: calc(100% - 50px);
        overflow-y: auto;
        height: 500px; /* Adjusted for better visibility */
        max-height: 70vh; /* Limit height based on viewport */
        scrollbar-width: thin;
        scroll-behavior: auto; /* Changed from smooth to auto for immediate scrolling */

        li {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 7px 0;
            border-bottom: 1px solid ${({ theme }) => theme.colors.border.ccc};
            grid-gap: 10px;
            button {
                margin: 0 5px;
            }

            &:hover {
                background-color: #f5f5f5;
            }

            &.disabled {
                opacity: 0.5;
                cursor: not-allowed;
                pointer-events: none;
                
                &:hover {
                    background-color: transparent;
                }
                
                input[type='checkbox'] {
                    cursor: not-allowed;
                }
            }

            input[type='checkbox'] {
                margin-right: 10px;
            }

            span {
                margin-right: 8px;

                &:nth-of-type(1) {
                    font-weight: bold;
                    min-width: 40px;
                }
            }
        }
    }
`;


